import { render } from "./ReportGoalsEditor.vue?vue&type=template&id=774c4630&scoped=true"
import script from "./ReportGoalsEditor.vue?vue&type=script&lang=js"
export * from "./ReportGoalsEditor.vue?vue&type=script&lang=js"

import "./ReportGoalsEditor.vue?vue&type=style&index=0&id=774c4630&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774c4630"],['__file',"resources/js/components/insights/ReportGoalsEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "774c4630"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('774c4630', __exports__)) {
    api.reload('774c4630', __exports__)
  }
  
  module.hot.accept("./ReportGoalsEditor.vue?vue&type=template&id=774c4630&scoped=true", () => {
    api.rerender('774c4630', render)
  })

}


export default __exports__